import React from 'react';
import { observer } from 'mobx-react';
import { makeAutoObservable } from 'mobx';
import { CombinedOutlookLocationViewer } from './CombinedSearchResultsStateOutlook';
import { Stack, Text } from '@fluentui/react';
import CombinedSearchResultsEntityNav from './CombinedSearchResultsEntityNav';
import { IContextCommands, IOutlookAppCommands, OutlookMessageMode } from '../state/CorporateArchiveStates/LegalEntityDocumentsStateOutlook';
import API, { IGlobalLocations, IUserConfigPackage } from '../API';

export class OutlookTabSuggestedState {
	
	userConfig: IUserConfigPackage;
	commands: IOutlookAppCommands;
	
	public suggested: CombinedOutlookLocationViewer;
	private initialLoaded: boolean = false;
	
	constructor(userConfig: IUserConfigPackage, commands: IOutlookAppCommands, ctxCommands: IContextCommands) {
		this.userConfig = userConfig;
		this.commands = commands;
		
		this.suggested = new CombinedOutlookLocationViewer(
					userConfig,
					commands,
					ctxCommands,
				);
		
		makeAutoObservable(this);
		
	}

	ensureInitialLoaded() {
		if(!this.initialLoaded) {
			this.initialLoaded = true;
			this.updateSuggested();
		}
	}

	public async updateSuggested() {
		this.suggested.setLoading(true);

		let api = new API(await this.userConfig.getToken());
		let itemInfo = await this.commands.getActiveItemInfo();
		let recipients = (itemInfo.recipients || []).map((r) => r.emailAddress);
		let from = itemInfo.from ? [itemInfo.from.emailAddress] : [];
		let subject = itemInfo.subject || '';

		//If you received a message, you are going to file to the sender. If you're sending, you're more interested in the recipient.
		let relevantSenderOrRecipient =
			this.commands.getMessageMode() === OutlookMessageMode.Compose
				? recipients
				: from;

		this.setSuggested(
			await api.suggested(
				relevantSenderOrRecipient,
				subject,
				itemInfo.id || '',
				itemInfo.conversationId || '',
				itemInfo.internetMessageId || '',
			),
		);	
	}

	public setSuggested(suggested: IGlobalLocations) {
		this.suggested.setResults(suggested);
	}
}

export interface IOutlookTabSuggestedProps {
	state: OutlookTabSuggestedState;
}

class OutlookTabSuggested extends React.Component<IOutlookTabSuggestedProps,{}> {
	componentDidMount(): void {
		this.props.state.ensureInitialLoaded();
	}

	render(): React.ReactNode {

		if (
			this.props.state.suggested.allItems?.any ||
			this.props.state.suggested.loading
		) {
			return (
				<Stack>
					<CombinedSearchResultsEntityNav state={this.props.state.suggested} />
				</Stack>
			);
		} else {
			//There's no items
			return <Text>No suggested locations.</Text>;
		}
	}
}

export default observer(OutlookTabSuggested);
